// Spec 078 FR-028 — o que aparece enquanto o chunk 3D baixa (fallback do React.lazy). DOM puro,
// SEM three.js: é importado pela tela da linha antes de o motor existir. Nunca uma área preta.
import * as React from "react";
import { Loader2 } from "lucide-react";

export interface SceneSkeletonProps {
  label?: string;
  /** progresso 0–100 quando conhecido */
  progress?: number | null;
}

export function SceneSkeleton({
  label = "Carregando cena 3D…",
  progress = null,
}: SceneSkeletonProps): React.ReactElement {
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-3 rounded-md border bg-card text-sm text-muted-foreground"
      role="status"
      aria-live="polite"
      data-testid="scene-skeleton"
    >
      <Loader2 className="h-5 w-5 motion-safe:animate-spin" aria-hidden />
      <span>{label}</span>
      {progress !== null ? (
        <div className="h-1.5 w-40 overflow-hidden rounded-full bg-bg-band">
          <div
            className="h-full w-[var(--scene-progress)] rounded-full bg-primary transition-[width]"
            style={{ "--scene-progress": `${Math.round(progress)}%` } as React.CSSProperties}
          />
        </div>
      ) : null}
    </div>
  );
}
